<div class="card p-2 m-2">
    <div class="sticky-top">
        <div class="Tabletitle">Admin Configurations</div>
    </div>
    <div class="card-body">
        <form>
            <div class="form-group row">
                <span class="form-group ml-3 form-label-105"></span>
                <div class="col mb-2">
                    <button mat-stroked-button class="float-right" title="update Configuration" (click)="updateConfiguration()">
                        <mat-icon>edit</mat-icon>Update Configuration
                    </button>
                </div>
            </div>
            <div class="input-group-sm mb-3 input-group col-12" *ngFor="let feature of allConfig">
                <div class="input-group-prepend">
                    <span class="input-group-text form-label-120">{{ feature.key }}</span>
                </div>
                <input *ngIf="feature.type == 'string'" class="form-control" [ngModelOptions]="{standalone: true}" type="text" [(ngModel)]="feature.value">
                <input *ngIf="feature.type == 'password'" class="form-control" [ngModelOptions]="{standalone: true}" type="password" [(ngModel)]="feature.value">
                <input *ngIf="feature.type == 'number'" class="form-control" [ngModelOptions]="{standalone: true}" type="number" [(ngModel)]="feature.value">
                <mat-slide-toggle *ngIf="feature.type == 'boolean'" class="feature-toggle"                                
                        [ngModelOptions]="{standalone: true}" [(ngModel)]="feature.value">
                </mat-slide-toggle>
            </div>
        </form>
    </div>
</div>